import { Component } from '@angular/core';
import { OffersModalService } from '~app/modules/product/services/offers-modal.service';

@Component({
  selector: 'app-cart-add-failed-alert',
  templateUrl: './cart-add-failed-alert.component.html',
  styleUrls: ['./cart-add-failed-alert.component.scss']
})
export class CartAddFailedAlertComponent {

  constructor(private readonly offersModalSvc: OffersModalService) {
  }

  openOtherOffersModal() {
    this.offersModalSvc.openOtherOffersModal$.next();
  }
}
